module.exports = __webpack_public_path__ + "img/card.f7fd7286.svg";